import { render, staticRenderFns } from "./UnreadMessageList.vue?vue&type=template&id=3663ea63&scoped=true&"
import script from "./UnreadMessageList.vue?vue&type=script&lang=js&"
export * from "./UnreadMessageList.vue?vue&type=script&lang=js&"
import style0 from "./UnreadMessageList.vue?vue&type=style&index=0&id=3663ea63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663ea63",
  null
  
)

export default component.exports